"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountBulkCleanApi = accountBulkCleanApi;
exports.accountBulkDisableApi = accountBulkDisableApi;
exports.accountBulkEnableApi = accountBulkEnableApi;
exports.accountBulkHardDeleteApi = accountBulkHardDeleteApi;
exports.accountBulkRestoreApi = accountBulkRestoreApi;
exports.accountBulkSoftDeleteApi = accountBulkSoftDeleteApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * account bulk enable
 * @param payload
 * @returns api response
 * @description this function used to enable account of given id's.
 */
function accountBulkEnableApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accountBulk.enable), params);
}

/**
 * account bulk disable
 * @param payload
 * @returns api response
 * @description this function used to disable account of given id's.
 */
function accountBulkDisableApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accountBulk.disable), params);
}

/**
 * account bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete account of given id's.
 */
function accountBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accountBulk.softDelete), params);
}

/**
 * account bulk restore soft deleted
 * @param payload
 * @returns api response
 * @description this function used to restore soft deleted account of given id's.
 */
function accountBulkRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accountBulk.restore), params);
}

/**
 * account bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to hard delete account of given id's.
 */
function accountBulkHardDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accountBulk.hardDelete), params);
}

/**
 * account bulk clean
 * @param payload
 * @returns api response
 * @description this function used to bulk clean account of given id's.
 */
function accountBulkCleanApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accountBulk.clean), params);
}